import { getCommonImageAttributes } from '@/components/tiptap-editor/tiptap-extension/image-utils';
import { mergeAttributes } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ZyInlineImageNodeView from './zyinline-image-node-view';

export const ZyInlineImageHeadless = Image.extend({
    name: 'zyInlineImage',

    addOptions() {
        const parentOptions = this.parent?.();

        return {
            inline: true,
            allowBase64: parentOptions?.allowBase64 ?? false,
            HTMLAttributes: parentOptions?.HTMLAttributes ?? {},
            resize: parentOptions?.resize ?? false,
        };
    },
    addAttributes() {
        return getCommonImageAttributes(this.parent);
    },
    parseHTML() {
        return [
            {
                tag: 'img[data-inline-image="true"]',
                priority: 1000,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { 'data-inline-image': 'true' })];
    },
});

export const ZyInlineImage = ZyInlineImageHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyInlineImageNodeView, { as: 'span' });
    },
});
